// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IHomeWelcomeApi,
  IHomeWelcomeApiRequest,
  IHomeWelcomeApiGetAllAttrs,
  IHomeWelcomeApiGetAllResponse,
  IHomeWelcomeApiGetAttrs,
  IHomeWelcomeApiGetResponse,
  IHomeWelcomeApiSaveAttrs,
  IHomeWelcomeApiSaveResponse,
} from 'interfaces/back-office/content-management/home/welcome/home-welcome-api.interface'
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class HomeWelcomeApi extends BaseApi<IHomeWelcomeApi> implements IHomeWelcomeApiRequest {
  readonly url = ApiConstant.CONTENT_HOME_WELCOME_URL
  private welcomeUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get home welcomes
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IHomeWelcomeApiGetAllAttrs} payload
   *
   * @return {Promise<IHomeWelcomeApiGetAllResponse>} Promise<IHomeWelcomeApiGetAllResponse>
   */
  async homeWelcome_getHomeWelcomes(payload: IHomeWelcomeApiGetAllAttrs): Promise<IHomeWelcomeApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.welcomeUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home welcome
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IHomeWelcomeApiGetAttrs} payload
   *
   * @return {Promise<IHomeWelcomeApiGetResponse>} Promise<IHomeWelcomeApiGetResponse>
   */
  async homeWelcome_getHomeWelcome(payload: IHomeWelcomeApiGetAttrs): Promise<IHomeWelcomeApiGetResponse> {
    try {
      const response = await this.POST(`${this.welcomeUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home welcome
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IHomeWelcomeApiSaveAttrs} payload
   *
   * @return {Promise<IHomeWelcomeApiSaveResponse>} Promise<IHomeWelcomeApiSaveResponse>
   */
  async homeWelcome_saveHomeWelcome(payload: IHomeWelcomeApiSaveAttrs): Promise<IHomeWelcomeApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: payload.params?.id ? `${this.welcomeUrl}/update/${payload.params.id}` : `${this.welcomeUrl}/create`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
